import BannerImgText from '@/components/BannerImgText';
import Card from '@/components/Card';
import EmptyResult from '@/components/EmptyResult';
import FileUpload from '@/components/FileUpload';
import { useDetectionOrientation } from '@/hooks/ai.hooks';
import { useCallback, useState } from 'react';

const OrientationDetectionPage = () => {
  const [file, setFile] = useState<File>();
  const { mutate, isPending, data } = useDetectionOrientation();

  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  const result: any = data; // I need to create the type for it.

  const onDetectOrientation = useCallback(() => {
    mutate(file);
  }, [file]);

  return (
    <div className="container">
      <BannerImgText
        title="Détection de l'orientation"
        img="media/ia-images/orientation.webp"
      />

      <div className="grid grid-cols-2 gap-3">
        <Card title="Séléction des fichiers">
          <div className="mb-5">
            <FileUpload setFileUpload={setFile} />
          </div>
          <div className="text-center">
            <button
              className="btn btn-fill btn-primary justify-center w-20"
              onClick={onDetectOrientation}
              disabled={!file}
            >
              {isPending ? '...En Cours' : 'GO'}
            </button>
          </div>
        </Card>
        <Card title="Résultat de l'analyse">
          {!data && (
            <div>
              <EmptyResult text="Aucune analyse trouvé" />
            </div>
          )}
          {!isPending && data && (
            <div className={data ? '' : 'hidden'}>
              <div>
                Orientation du véhicule: <b>{result.data}</b>
              </div>
            </div>
          )}
        </Card>
      </div>
    </div>
  );
};

export default OrientationDetectionPage;
